import React from "react";
import { Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import Style from "../../../../../styles/js/StyleCallList.js";
import * as Constants from "../../../../../consts/Constants.js";
import { callsErrors } from "../../../../../consts/ErrorMessages.js";
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Button from "@material-ui/core/Button";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import Tooltip from '@mui/material/Tooltip';
import CircularProgressWithLabel from "../../../../../components/common/CircularProgressWithLabel.js";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import IconButton from '@mui/material/IconButton';
import { formatDateDDMMYYYYHHMM, createByteArray } from "../../../../../plas/utils";
import ConfirmIcon from '@mui/icons-material/Done';
import CancelIcon from '@mui/icons-material/Cancel';
import LoadingButton from '@mui/lab/LoadingButton';

import service from '../../../../../plas/services/calls/service';
import alerter from '../../../../alerts/alerter';

export default function CallResults( { call, disable, disabled } ) {

  const inputFile = React.useRef(null) 

  const [newResult, setNewResult] = React.useState(null);
  const [askSend, setAskSend] = React.useState(false);
  const [progress, setProgress] = React.useState(null);
  const [downloadingA, setDownloadingA] = React.useState({}); // Descargas de result files

  const style = Style();

  const onButtonClick = () => {
    inputFile.current.click();
  }

  const onSelectFile = (event) => {
    event.stopPropagation();
    event.preventDefault();
    var file = event.target.files[0];

    if (file.type == null || file.type === "") {
      alerter.showError({'message': callsErrors.type});
      return;
    }

    var bin = {
        name: file.name,
        type: file.type,
        data: createByteArray(URL.createObjectURL(file))
    }

    setNewResult([...newResult, bin]);
  }

  const removeBin = (event, binToRemove) => {
    event.stopPropagation();
    event.preventDefault();

    setNewResult(newResult.filter(
      function(bin) { 
        return bin !== binToRemove
      }
    ));
  }

  const sendResults = () => {

    if (newResult.length === 0) {
      alerter.showError({'message': callsErrors.resultEmpty })
      return;
    }

    disable(true);
    setProgress(0);

    service.api.callResults.create(call.id, newResult, {
      onUpdateProgress: value => {
        setProgress(value);
      },
      result: (response) => {
        if (response.result != null) {
          call.result = response.result;
          setNewResult(null);
          setAskSend(false);
        } else {
          alerter.showError(response.error);
        }
        disable(false);
        setProgress(null);
      }
    });
  }

  const getResultFile = (call, file) => {

    setDownloadingA(prevState => {
      const state = { ...prevState };
      state[file.id] = 0;
      return state;
    });

    service.api.callResults.getFile(call.id, call.result.id, file.id, {
      success: () =>  { 
        setDownloadingA(prevState => {
          const state = { ...prevState };
          state[file.id] = undefined;
          return state;
        });
      },
      error: () =>  { 
        setDownloadingA(prevState => {
          const state = { ...prevState };
          state[file.id] = undefined;
          return state;
        });
      } ,
      onDownloadProgress: (value) => {
        setDownloadingA(prevState => {
          const state = { ...prevState };
          state[file.id] = value;
          return state;
        });
      }
    });
  }

  return (
    <div className={style.box} >

      <Card style={{ marginBottom: "15px"}}>
        <div className={style.itemHeader}>
          <Typography className={style.titleInitial}>
            Resultados
          </Typography>
        </div>
        <div style={{ paddingLeft: "12px", paddingRight: "12px" }}>
          { call.result != null && newResult == null ? (
            <div className={style.itemContent}>
              <p style={{ fontSize: '17px', textAlign: 'left'}}>
                Fecha de últimos resultados: { formatDateDDMMYYYYHHMM(call.result.time) }
              </p>
              <Divider style={{ marginTop: '8px' }}/>
              <Stack style={{overflow: "auto", paddingTop: '8px', paddingBottom: '8px'}} direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
                <p style={{display:"flex", fontSize: '17px', justifyContent:"center", alignItems:"center", textAlign:"center", width: "70px"}}>
                  Archivos
                </p>
                { call.result != null && call.result.files.map((file) => 
                  (<div>
                    { downloadingA[file.id] !== undefined ? 
                      (
                        <Stack alignItems="center" style={{width:"110px"}}>
                          <CircularProgressWithLabel style={{width:"35px", height:"35px" }} value={downloadingA[file.id]} />
                        </Stack>
                      ) :
                      (
                      <Stack alignItems="center">
                        <IconButton size="large" width="50px"  height="50px" onClick={ () => { getResultFile(call,file); }} >
                          <FilePresentIcon fontSize="inherit" />
                        </IconButton>
                        <Tooltip title={file.bin.name}>
                            <span style={{fontSize:"14px", textOverflow: "ellipsis", whiteSpace:"nowrap", width:"110px", textAlign:"center", overflow:"hidden"}}>{file.bin.name}</span>
                        </Tooltip>
                      </Stack>
                      )
                    }
                  </div>))
                }
              </Stack>
              <Divider style={{ marginTop: '8px' }}/>
            </div>) : (null)
          }
          { newResult != null ? (
            <div>
              <div className={style.itemContent}>
                <p style={{ fontSize: '17px', textAlign: 'left'}}>
                  Por favor, cargue los archivos de los nuevos resultados.
                </p>
                <Divider style={{ marginTop: '8px' }}/>
                <Stack style={{overflow: "auto", paddingTop: '8px', paddingBottom: '8px'}} direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
                  <p style={{display:"flex", fontSize: '17px', justifyContent:"center", alignItems:"center", textAlign:"center", width: "70px"}}>
                    Archivos
                  </p>
                  { progress == null ? (
                     newResult.map((bin) => (
                    <Stack alignItems="center">
                     <IconButton size="large" width="50px"  height="50px">
                        <FilePresentIcon fontSize="inherit" />
                      </IconButton>
                      <Tooltip title={bin.name}>
                          <span style={{fontSize:"14px", textOverflow: "ellipsis", whiteSpace:"nowrap", width:"110px", textAlign:"center", overflow:"hidden"}}>{bin.name}</span>
                      </Tooltip>
                      <Tooltip title="Borrar">
                        <IconButton size="small" onClick={ (event) => { removeBin(event,bin) }}>
                          <DeleteForeverIcon fontSize="inherit" />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                    )
                  )
                    ) :
                    (<Stack alignItems="center" style={{width:"110px"}}>
                      <CircularProgressWithLabel style={{width:"35px", height:"35px" }} value={progress} />
                    </Stack>)
                  }
                           
                  <Stack alignItems="center">
                    <IconButton onClick={onButtonClick} size="large" width="50px"  height="50px" >
                      <UploadFileIcon fontSize="inherit" />
                      <input type='file' id='file' ref={inputFile} style={{display: 'none'}} onChange={ (event) => onSelectFile(event) }/>
                    </IconButton>
                    <span style={{fontSize:"14px", textOverflow: "ellipsis", whiteSpace:"nowrap", width:"110px", textAlign:"center"}}>Subir archivo</span>
                  </Stack>
                </Stack>
                <Divider style={{ marginTop: '8px' }}/>
              </div>
              <div className={style.itemContent} style={{ textAlign:"center"}} >
                <Button svariant="contained" disabled={disabled} style={{background: Constants.COLOR_GRAY, color: 'white', marginRight:'8px', width:'150px' }} onClick={ () => { setNewResult(null) }}>
                  <b>Cancelar</b>
                </Button>
                <Button variant="contained" disabled={disabled} style={{background: Constants.COLOR_PRIMARY, color: 'white', marginLeft: '8px', width:'150px' }} onClick={ () => { setAskSend(true) }}>
                  <b>Confirmar</b>
                </Button>
              </div>
            </div>) : (
              <div className={style.itemContent} style={{textAlign:"center" }}>
                <Button variant="contained" disabled={disabled} style={{background: Constants.COLOR_PRIMARY, color: 'white', width:'200px' }} onClick={ () => { setNewResult([]) }}>
                  <b>Nuevo resultado</b>
                </Button>
              </div>
            )
          }
        </div>
      </Card>

      <Dialog
        open={askSend}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle>
          ¿Publicar resultados?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Los postulados a la convocatoria recibiran una notificación indicando que hay nuevos resultados disponibles en la convocatoria. Los resultados seran visibles para todos los usuarios.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" 
              style={{background: Constants.COLOR_GRAY, color: 'white' }}
              disabled={disabled}
              startIcon={<CancelIcon/>}
              onClick={ () => { setAskSend(false) } }>
              <b>Cancelar</b>
            </Button>
            <LoadingButton 
              loading={progress != null}
              startIcon={<ConfirmIcon />}
              disabled={disabled}
              loadingPosition="start"
              variant="contained" 
              style={{background: Constants.COLOR_PRIMARY, color: 'white' }}
              onClick={ () => { sendResults() }} 
              autoFocus>
                <b>Confirmar</b>
            </LoadingButton>

        </DialogActions>
      </Dialog>

    </div>

  );
}
